module.exports = __webpack_public_path__ + "img/w1.96f858f6.jpg";